import { initVisioCalendar } from './render';
import { handleClickItemListView } from './handlers/list';
import { initCancelSession } from './handlers/calendar';
import { initVisioListFilter } from './handlers/filter';

export function initVisio() {
	initVisioCalendar();
	handleClickItemListView();
	initCancelSession();
	initVisioListFilter();
}
